<template>
  <v-col>
    <v-data-table
      :key="index"
      :headers="headers"
      :items="users.data"
      :server-items-length="users.total"
      :footer-props="{ itemsPerPageOptions: [10, 15] }"
      @pagination="paginate"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-dialog
            v-model="dialog"
            max-width="650"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="info"
                dark
                class="mb-2"
                v-on="on"
              >
                New User
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.name"
                        label="User Name"
                        :error-messages="errors.getMessage('name')"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="editedItem.email"
                        label="E-mail"
                        :error-messages="errors.getMessage('email')"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="editedItem.password"
                        label="Password"
                        type="password"
                        :error-messages="errors.getMessage('password')"
                      />
                    </v-col>
                    <template v-if="editedItem.id === 1">
                      <center>
                        <v-alert
                          type="info"
                          class="pa-1"
                        >
                          This is Admin account has full permission to access
                          overall.
                        </v-alert>
                      </center>
                    </template>
                    <template v-else>
                      <template v-if="hide">
                        <v-col>
                          <div
                            class="btn text-center"
                            @click="hide = false"
                          >
                            <v-btn icon>
                              <v-icon>mdi-unfold-less-horizontal</v-icon>
                            </v-btn>
                          </div>
                        </v-col>
                      </template>
                      <template v-else>
                        <v-col cols="12">
                          <v-text-field
                            v-model="editedItem.roleName"
                            label="Role Title"
                            :error-messages="errors.getMessage('roleName')"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="3"
                        >
                          <v-switch
                            v-model="editedItem.productCreate"
                            label="Product Create"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.productEdit"
                            label="Product Edit"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.productLabel"
                            label="Product Label"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.productDetail"
                            label="Product Details"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.productRemove"
                            label="Product Remove"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.userManage"
                            label="User/Role Manage"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.backups"
                            label="Backup/Restore"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.reports"
                            label="Reports"
                            hide-details
                          />
                          <!--  -->
                          <v-switch
                            v-model="editedItem.customProductManage"
                            label="Custom Product Manage"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.repairGalleryManage"
                            label="Repair Gallery Manage"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.repairManage"
                            label="Repair Manage"
                            hide-details
                          />

                          <!--  -->
                        </v-col>

                        <v-col
                          cols="12"
                          md="3"
                        >
                          <v-switch
                            v-model="editedItem.shopListManage"
                            label="Shop Manage"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.billManage"
                            label="Bills Manage"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.saleList"
                            label="Sale List"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.saleCreate"
                            label="Sale Create"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.saleDetails"
                            label="Sale Details"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.salePrint"
                            label="Sale Print"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.saleRefund"
                            label="Sale Refund"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.saleExport"
                            label="Sale Export"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.saleEmail"
                            label="Sale Email"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.orderRemove"
                            label="TRXs Remove"
                            hide-details
                          />

                          <v-switch
                            v-model="editedItem.refundList"
                            label="Sale Returns List"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.refundDetails"
                            label="Refund Details"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.refundPrint"
                            label="Sale return Print"
                            hide-details
                          />
                        </v-col>

                        <v-col
                          cols="12"
                          md="3"
                        >
                          <v-switch
                            v-model="editedItem.supplierCreate"
                            label="Supplier Create"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.supplierEdit"
                            label="Supplier Edit"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.supplierDetials"
                            label="Supplier Details"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.supplierRemove"
                            label="Supplier Remove"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.outOfstock"
                            label="View out stock items"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.stockTracking"
                            label="Stock tracking"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.categoryCreate"
                            label="Category Create"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.categoryEdit"
                            label="Category Edit"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.categoryRemove"
                            label="Category Remove"
                            hide-details
                          />

                          <v-switch
                            v-model="editedItem.purchaseList"
                            label="Purchase List"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.purchaseCreate"
                            label="Purchase Create"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.purchaseDetails"
                            label="Purchase Details"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.purchasePrint"
                            label="Purchase Print"
                            hide-details
                          />
                        </v-col>

                        <v-col
                          cols="12"
                          md="3"
                        >
                          <v-switch
                            v-model="editedItem.customerCreate"
                            label="Customer Create"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.customerEdit"
                            label="Customer Edit"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.customerDetials"
                            label="Customer Details"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.customerRemove"
                            label="Customer Remove"
                            hide-details
                          />

                          <v-switch
                            v-model="editedItem.warehouseCreate"
                            label="Warehouse Create"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.warehouseEdit"
                            label="Warehouse Edit"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.warehouseDetials"
                            label="Warehouse Details"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.warehouseRemove"
                            label="Warehouse Remove"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.generalSetting"
                            label="General Setting"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.mailSetting"
                            label="Mail Setting"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.logoSetting"
                            label="logo Setting"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.termsSetting"
                            label="Terms Setting"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.paymentList"
                            label="Payment List"
                            hide-details
                          />
                          <v-switch
                            v-model="editedItem.paymentDetails"
                            label="Payment Details"
                            hide-details
                          />
                        </v-col>
                      </template>
                    </template>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="hide = !hide"
                >
                  Fold/UnFold
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:item.avatar="{ item }">
        <v-edit-dialog>
          <v-list-item-avatar>
            <v-img
              :src="'/storage/' + item.avatar"
              lazy-src="/storage/default_img/no_image.png"
              aspect-ratio="1"
              max-width="50"
              max-height="50"
            />
          </v-list-item-avatar>
          <template v-slot:input>
            <v-file-input
              v-model="editedItem.avatar"
              label="Select File"
              placeholder="Upload Avatar"
              accept="image/jpg, image/png, image/jpeg"
              :loading="editedItem.avatar !== null"
              @change="uploadUserAvatar(item)"
            />
          </template>
        </v-edit-dialog>
      </template>

      <template v-slot:no-data>
        <p>Record not found !</p>
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    index: 1,
    hide: true,
    defaultItem: {
      avatar: "",
      email: "",
      name: "",
      password: "",
    },
    dialog: false,
    editedIndex: -1,
    editedItem: {
      avatar: null,
      email: "",
      name: "",
      password: "",
    },
    headers: [
      {
        align: "start",
        sortable: false,
        text: "Avatar",
        value: "avatar",
      },
      {
        align: "start",
        sortable: false,
        text: "Name",
        value: "name",
      },
      { sortable: false, text: "E-mail", value: "email" },
      { sortable: false, text: "Designation", value: "roleName" },

      { sortable: false, text: "Actions", value: "actions" },
    ],

    users: [],
  }),
  computed: {
    ...mapGetters({
      errors: "validation/pull",
    }),

    formTitle() {
      if (this.editedIndex === -1) {
        return "New User";
      }

      return "Edit User";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
    deleteItem(item) {
      const index = this.users.data.indexOf(item);

      if (confirm("Are you sure you want to delete this user ?")) {
        window.axios.delete(`/user/${item.id}`).then((response) => {
          if (item.id > 1) {
            this.users.data.splice(index, 1);
          }
          this.feedback(response.data.message);
        });
      }
    },
    editItem(item) {
      this.editedIndex = this.users.data.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },

    paginate(event) {
      window.axios
        .get(`/user?page=${event.page}`, {
          params: { usersPerPage: event.itemsPerPage },
        })
        .then((response) => {
          this.users = response.data.userList;
        });
    },
    save() {
      if (this.editedIndex > -1) {
        window.axios
          .patch(`/user/${this.editedItem.id}`, this.editedItem)
          .then((response) => {
            Object.assign(this.users.data[this.editedIndex], this.editedItem);
            this.close();
            this.feedback(response.data.message);
          });
      } else {
        window.axios.post("/user", this.editedItem).then((response) => {
          this.users.data.push(response.data.user);
          this.close();
          this.feedback(response.data.addedMessage);
          setTimeout(() => {
            this.editedItem.avatar = null;
          }, 1000);
        });
      }
    },

    uploadUserAvatar(item) {
      if (this.editedItem.avatar !== null) {
        const index = this.users.data.indexOf(item),
          formData = new FormData();

        formData.append(
          "avatar",
          this.editedItem.avatar,
          this.editedItem.avatar.name
        );
        window.axios
          .post(`/user/avatar/${item.id}`, formData)
          .then((response) => {
            this.users.data[parseInt(index)].avatar = response.data.avatar;
            this.editedItem.avatar = null;
            this.feedback(response.data.message);
          });
      }
    },
  },
};
</script>
